import React from 'react';
import { useTranslation } from 'react-i18next';
import Asterisk from '../common/Asterisk/Asterisk';
import "./CommercialUnit.css";
import { FormError, hasError } from '../../utils/context/FormErrorContext';
import AIRPNumberInput from '../common/AIRPNumberInput/AIRPNumberInput';

interface RateProps {
    formData: Record<string, unknown>,
    handleCurrencyChange: (value: number | null, name: string) => void,
    currencySymbol?: string,
    errors: FormError[],
    disabled?: boolean,
    showAsterisk?: boolean
}

export default function OperatingExpense(props: RateProps): JSX.Element {
    const { t } = useTranslation('unit');

    const cbrClassName = hasError(props.errors, "currentBaseRent") ? "table-error" : ""
    const arClassName = hasError(props.errors, "annualRent") ? "table-error" : ""
    const propertyTaxRecoveryClassName = hasError(props.errors, "propertyTaxRecovery") ? "table-error" : ""
    const operatingRecoveryClassName = hasError(props.errors, "operatingRecovery") ? "table-error" : ""
    const tenantImprovementClassName = hasError(props.errors, "tenantImprovement") ? "table-error" : ""


    return (
        <tbody>
            <tr>
                <td className='label-cell padding-left-10 padding-right-10'>
                    {t('headings.annual-rent')}
                </td>
                <td className={'currency-input-td ' + arClassName}>
                    <AIRPNumberInput 
                        name="annualRent"
                        symbol='$'
                        textAlign='right'
                        initialValue={props.formData.annualRent as string}
                        onChange={(value: number | null) => props.handleCurrencyChange(value, "annualRent")}
                        tooltip={t('tooltips.annual-rent-tooltip')}/>
                </td>
            </tr>
            <tr>
                <td className='label-cell padding-left-10 padding-right-10'>
                    {t('headings.current-base-rent')} {props.showAsterisk && <Asterisk />}
                </td>
                <td className={'currency-input-td ' + cbrClassName}>
                    <AIRPNumberInput 
                        name="currentBaseRent"
                        symbol='$'
                        textAlign='right'
                        initialValue={props.formData.currentBaseRent as string}
                        onChange={(value: number | null) => props.handleCurrencyChange(value, "currentBaseRent")}
                        tooltip={t('tooltips.current-base-rent-tooltip')}/>
                </td>
            </tr>
            <tr>
                <td className='label-cell padding-left-10 padding-right-10'>
                    {t('headings.prop-tax-recoveries')}
                </td>
                <td className={propertyTaxRecoveryClassName}>
                    <AIRPNumberInput 
                        name="propertyTaxRecovery"
                        symbol='$'
                        textAlign='right'
                        initialValue={props.formData.propertyTaxRecovery as string}
                        onChange={(value: number | null) => props.handleCurrencyChange(value, "propertyTaxRecovery")}
                        tooltip={t('tooltips.prop-tax-recoveries-tooltip')}/>
                </td>
            </tr>
            <tr>
                <td className='label-cell padding-left-10 padding-right-10 no-wrap'>
                    {t('headings.operating-recoveries')}
                </td>
                <td className={operatingRecoveryClassName}>
                    <AIRPNumberInput 
                        name="operatingRecovery"
                        symbol='$'
                        textAlign='right'
                        initialValue={props.formData.operatingRecovery as string}
                        onChange={(value: number | null) => props.handleCurrencyChange(value, "operatingRecovery")}
                        tooltip={t('tooltips.operating-recoveries-tooltip')}/>
                </td>
            </tr>
            <tr>
                <td className='label-cell padding-left-10 padding-right-10'>
                    {t('headings.tenant-improvements')}
                </td>
                <td className={tenantImprovementClassName}>
                    <AIRPNumberInput 
                        name="tenantImprovement"
                        symbol='$'
                        textAlign='right'
                        initialValue={props.formData.tenantImprovement as string}
                        onChange={(value: number | null) => props.handleCurrencyChange(value, "tenantImprovement")}
                        tooltip={t('tooltips.tenant-improvements-tooltip')}/>
                </td>
            </tr>
        </tbody>
    );
}
